export var ManagerHistorySearchType;
(function (ManagerHistorySearchType) {
    ManagerHistorySearchType["DISPATCH_AREA"] = "DISPATCH_AREA";
    /** 예약차량(reservedVehicle) 변경 — 배차 차트 이동, 예약 수정 */
    ManagerHistorySearchType["RESERVED_VEHICLE"] = "RESERVED_VEHICLE";
    /** 지정차량(assignedVehicle) 지정 — 전자계약서, 예약 수정 출고 섹션 */
    ManagerHistorySearchType["ASSIGNED_VEHICLE"] = "ASSIGNED_VEHICLE";
    ManagerHistorySearchType["DRIVER_LICENSE_IMAGE"] = "DRIVER_LICENSE_IMAGE";
})(ManagerHistorySearchType || (ManagerHistorySearchType = {}));
